import { render, staticRenderFns } from "./PositionsTable.vue?vue&type=template&id=31484e6b&scoped=true&"
import script from "./PositionsTable.vue?vue&type=script&lang=js&"
export * from "./PositionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31484e6b",
  null
  
)

export default component.exports